import PropTypes from 'prop-types'
import React from 'react'
import DeleteButton from '../../molecules/buttons/DeleteButton'
import Table from '../../atoms/table/Table'
import Tr from '../../atoms/table/Tr'
import Th from '../../atoms/table/Th'
import Td from '../../atoms/table/Td'
import { TextButton } from '../../molecules/buttons/TextButton'
import DownloadIcon from '../../atoms/icons/DownloadIcon'
import LoadingIcon from '../../atoms/icons/LoadingIcon'

const ExportsTable = ({ exports = [], onDestroy, filterLabel, multipleExport }) => {
  const iconList = {
    'EN PROCESO': <LoadingIcon />,
    CANCELADO: <LoadingIcon />,
    RESUELTO: <DownloadIcon />
  }
  return (
    <div className="pb-8 pt-2">
      <Table
        spacing="normal"
        className="table-auto w-full"
        values={exports}
        head={
          <Tr body={false}>
            <Th>ID</Th>
            {multipleExport && <Th>Tipo de exportación</Th>}
            <Th>Creado por</Th>
            <Th>Fecha de creación</Th>
            <Th>Filtros aplicados</Th>
            <Th>Archivo</Th>
            <Th>Acciones</Th>
          </Tr>
        }
        body={exports.map(item => (
          <Tr className="bg-neutral-200" key={item.id}>
            <Td>{item.id}</Td>
            {multipleExport && <Td>{item.exportable_type}</Td>}
            <Td>{item.user}</Td>
            <Td>{item.created_at}</Td>
            <Td>
              {item.search_params
                ? Object.entries(item.search_params).map(([key, value]) => (
                    <div key={key}>
                      {filterLabel[key]}: {value.toString()}
                    </div>
                  ))
                : 'Resultados completos (sin filtros)'}
            </Td>
            <Td>
              {item.url ? (
                <TextButton
                  component="a"
                  className="w-fit"
                  linkProps={{ href: item.url, target: '_blank', rel: 'noreferrer' }}
                  startIcon={iconList[item.status]}
                >
                  Descargar
                </TextButton>
              ) : (
                <p className="flex gap-2 items-center">
                  {iconList[item.status]}
                  {item.status.toLowerCase().toUpperFirst()}
                </p>
              )}
            </Td>
            <Td>
              <DeleteButton onClick={() => onDestroy(item)} />
            </Td>
          </Tr>
        ))}
      />
    </div>
  )
}

export default ExportsTable

ExportsTable.propTypes = {
  exports: PropTypes.arrayOf(PropTypes.object),
  filterLabel: PropTypes.object,
  onDestroy: PropTypes.func.isRequired,
  multipleExport: PropTypes.bool
}
